/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $SurveyDetail = {
    properties: {
        id: {
    type: 'number',
    isRequired: true,
},
        name: {
    type: 'string',
    isRequired: true,
},
        details: {
    type: 'array',
    contains: {
        type: 'SurveyDataDetail',
    },
    isRequired: true,
},
    },
};